module.exports = __webpack_public_path__ + "img/xinmeiti.83a79ee9.png";